import createSagaMiddleware from "@redux-saga/core";
import { configureStore } from "@reduxjs/toolkit";
import { rootReducer } from "./Reducer";
import { watcherSaga } from "./Saga";
let sagaMiddleware = createSagaMiddleware();
const middleware = [sagaMiddleware];
export const store = configureStore({
    reducer: rootReducer,
    devTools: import.meta.env.CUSTOM_NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(middleware),
});
sagaMiddleware.run(watcherSaga);
